"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = exports.NodeCardSize = exports.MessageLevel = exports.NodeType = void 0;
/**
 * Available Node types in community
 */
var NodeType;
(function (NodeType) {
    NodeType["COMMUNITY"] = "community";
    NodeType["CATEGORY"] = "category";
    NodeType["GROUPHUB"] = "grouphub";
    NodeType["BOARD"] = "board";
})(NodeType || (exports.NodeType = NodeType = {}));
/**
 * Message levels in Community
 */
var MessageLevel;
(function (MessageLevel) {
    MessageLevel["ROOT"] = "root";
    MessageLevel["REPLY"] = "reply";
})(MessageLevel || (exports.MessageLevel = MessageLevel = {}));
var NodeCardSize;
(function (NodeCardSize) {
    NodeCardSize["XS"] = "xs";
    NodeCardSize["SM"] = "sm";
    NodeCardSize["LG"] = "lg";
})(NodeCardSize || (exports.NodeCardSize = NodeCardSize = {}));
/**
 * Available Entity types in community
 */
var EntityType;
(function (EntityType) {
    EntityType["COMMUNITY"] = "COMMUNITY";
    EntityType["CATEGORY"] = "CATEGORY";
    EntityType["GROUP_HUB"] = "GROUP_HUB";
    EntityType["FORUM"] = "FORUM";
    EntityType["FORUM_TOPIC"] = "FORUM_TOPIC";
    EntityType["FORUM_REPLY"] = "FORUM_REPLY";
    EntityType["BLOG"] = "BLOG";
    EntityType["BLOG_ARTICLE"] = "BLOG_ARTICLE";
    EntityType["BLOG_REPLY"] = "BLOG_REPLY";
    EntityType["TKB"] = "TKB";
    EntityType["TKB_ARTICLE"] = "TKB_ARTICLE";
    EntityType["TKB_REPLY"] = "TKB_REPLY";
    EntityType["EVENT"] = "EVENT";
    EntityType["EVENT_TOPIC"] = "EVENT_TOPIC";
    EntityType["EVENT_REPLY"] = "EVENT_REPLY";
    EntityType["IDEA"] = "IDEA";
    EntityType["IDEA_POST"] = "IDEA_POST";
    EntityType["IDEA_REPLY"] = "IDEA_REPLY";
    EntityType["OCCASION_TOPIC"] = "OCCASION_TOPIC";
    EntityType["OCCASION_REPLY"] = "OCCASION_REPLY";
    EntityType["USER"] = "USER";
    EntityType["CUSTOM"] = "CUSTOM";
})(EntityType || (exports.EntityType = EntityType = {}));
//# sourceMappingURL=enums.js.map